import { render, staticRenderFns } from "./TermsAndConditionsAcceptance.vue?vue&type=template&id=989e135e&scoped=true&"
import script from "./TermsAndConditionsAcceptance.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsAcceptance.vue?vue&type=style&index=0&id=989e135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989e135e",
  null
  
)

export default component.exports